import { addPathPrefix, getWithoutNilQuery } from '@/utils/path';
import { useRouter } from '@/router/useRouter';
import { aiProjectEditorRouteName } from '@/router/route-const';
/**
 * 进入 AI 编辑器统一入口，具体实现由入口组件根据项目配置决定。
 */
export function openAiEditor(query = {}, newWindow = false) {
    openAiProjectEditor(query, newWindow);
}
export function getGogoEditorHref(projectId) {
    return addPathPrefix(`/gogo/editor?projectid=${projectId}`);
}
export function openGogoEditor(projectId) {
    window.location.href = getGogoEditorHref(projectId);
}
export function getAiProjectEditorHref(query = {}) {
    const { router, route } = useRouter();
    const projectId = query.projectid || route.value?.query?.projectid;
    const routeQuery = getWithoutNilQuery({
        ...query,
        projectid: projectId,
        branch: query.branch || route.value?.query?.branch,
    });
    return router.value?.resolve({ name: aiProjectEditorRouteName, query: routeQuery })?.href;
}
export function openAiProjectEditor(query = {}, newWindow = false) {
    const url = getAiProjectEditorHref(query);
    if (newWindow) {
        window.open(url, '_blank', 'noopener=yes');
    }
    else {
        window.location.href = url;
    }
}
/** @deprecated 请使用 getAiProjectEditorHref，编辑器模式由项目配置决定 */
export function getAiEditorRemoteHref(query = {}) {
    return getAiProjectEditorHref(query);
}
/** @deprecated 请使用 openAiProjectEditor，编辑器模式由项目配置决定 */
export function openAiEditorRemote(query = {}, newWindow = false) {
    openAiProjectEditor(query, newWindow);
}
/**
 * 打开AI编辑器并删除页面文件
 */
export function openAiProjectEditorToDeletePage(options, newWindow = false) {
    const { projectid, pageId } = options;
    const fileName = pageId === 'aipage' ? 'index' : pageId.replace(/^aipage-/, '');
    openAiEditor({
        projectid,
        prompt: `删除文件 /pages/${fileName}.vue`,
    }, newWindow);
}
